import React, { useState } from "react";
import { client } from "../../client";
import { Canvas } from "@react-three/fiber";
import { OrbitControls, PerspectiveCamera } from "@react-three/drei";
import { Marquee } from "../../components";
import {
  AiOutlineInstagram,
  AiOutlineGithub,
  AiFillLinkedin,
} from "react-icons/ai";
import Hrsch from "../../components/Hrsch";

import { IoArrowForwardSharp } from "react-icons/io5";
import "./Footer.scss";

const Footer = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [emailError, setEmailError] = useState(false);

  const { name, email, message } = formData;

  const handleChangeInput = (e) => {
    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value });

    if (name === "email") {
      setEmailError(!e.target.validity.valid);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    const contact = {
      _type: "contact",
      name: name,
      email: email,
      message: message,
    };

    if (!name || !email || !message) {
      alert("Please fill in all fields");
      setLoading(false);
      return;
    }

    if (emailError) {
      alert("Please input a valid email address");
      setLoading(false);
      return;
    }

    client.create(contact).then(() => {
      setLoading(false);
      setIsFormSubmitted(true);
    });
  };

  return (
    <>
      <Marquee />
      <div id="footer">
        <div className="contact-section">
          <div id="hrsch-canvas">
            <h1>HELLO THERE YOU FABULOUS ARTIST!</h1>
            <h3>
              Are you ready to showcase your projects to the world? Our virtual
              platform is the perfect place to share your creativity and connect
              with fellow artists.
              <br />
              <br />
              So come on! Don't be shy! Fill out the contact form with your name
              and email address to become a member of our community.
            </h3>
          </div>
          <div className="social-media item">
            <div className="contact-info">
              <div className="email item">
                <h3>USER SUPPORT</h3>
                <span>indica@nevtik.org</span>
              </div>
 
              <div className="address item">
                <h3>LOCATION</h3>
                <span>Bogor, Indonesia</span>
              </div>
            </div>
          </div>
          <div className="footer-socials">
            <h3>SOCIAL MEDIA</h3>
            <span>
              <a href="https://www.instagram.com/horuschild" target="_blank">
                <AiOutlineInstagram />
              </a>
              <a href="https://www.github.com/horuschild" target="_blank">
                <AiOutlineGithub />
              </a>
              <a
                href="https://www.linkedin.com/in/zahra-indica-fathsyah/"
                target="_blank"
              >
                <AiFillLinkedin />
              </a>
            </span>
          </div>
        </div>

        <div className="contact-form col">
          <form className="contact-wrapper">
            <div className="row">
              <input
                type="text"
                name="name"
                id=""
                placeholder="NAME"
                value={name}
                onChange={handleChangeInput}
                required
              />
            </div>
            <div className="row">
              <input
                type="email"
                name="email"
                id=""
                placeholder="EMAIL"
                value={email}
                onChange={handleChangeInput}
                pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                title="Please enter a valid email address"
                required
              />
            </div>
            <div className="row">
              <textarea
                name="message"
                id="message"
                rows="5"
                placeholder="MESSAGE"
                value={message}
                onChange={handleChangeInput}
                required
              ></textarea>
            </div>
            <div className="row submit">
              <input
                type="submit"
                value={
                  isFormSubmitted
                    ? "THANK YOU!"
                    : loading
                    ? "SENDING"
                    : "SUBMIT"
                }
                onClick={handleSubmit}
              />
              <IoArrowForwardSharp className="send-icon" />
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Footer;
